module.exports = __webpack_public_path__ + "static/media/icon-printer.646328da.svg";